<template>
  <div class="div-master">
    <div class="live pb-5 d-flex flex-column justify-content-center">
      <Navbar />
      <b-container
        class="container d-flex flex-column justify-content-start pt-sm-5 pt-md-5 pt-lg-5 pt-xl-5 ao-vivo"
        v-if="palestra"
      >
        <b-row class="pt-5">
          <b-col class="col-12 title pt-sm-5">{{ palestra.title }}</b-col>
        </b-row>
        <b-row class="live-container">
          <b-col class="video col-12 col-lg-8 my-auto">
            <b-embed
              type="iframe"
              aspect="16by9"
              :src="palestraURL"
              allow="accelerometer"
              picture-in-picture
              allowfullscreen
            ></b-embed>
          </b-col>
          <b-col class="col-12 col-lg-4 pt-4 pt-lg-0 chat-col">
            <iframe
              width="400"
              height="500"
              :src="chatURL"
              frameborder="0"
              allowfullscreen
            ></iframe>
            <!-- <Chat :idPalestra="palestra._id" /> -->
          </b-col>
        </b-row>
        <b-row>
          <b-col class="title-text col-12">Sobre a palestra</b-col>
          <b-col class="text col-12">{{ palestra.description }}</b-col>
        </b-row>
      </b-container>

      <b-container v-if="!palestra && !isForbidden">
        <b-row class="pt-5">
          <b-col
            lg="6"
            class="text-no-video d-flex flex-column justify-content-center pb-5 pb-lg-0"
          >
            <p>Nenhuma transmissão no momento... Volte mais tarde</p>
          </b-col>
          <b-col lg="6">
            <b-img
              fluid
              :src="require('@/assets/Aguardar-ao-vivo/wait-live.png')"
            />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-modal
      id="modal-permissao"
      title="Inscreva-se na palestra"
      ok-only
      ok-title="Inscrever"
      @ok="onOkModal"
    >
      Você não se inscreveu nesta palestra. Realize a inscrição para poder
      assistí-la.
    </b-modal>
    <b-modal
      id="modal-pagina"
      title="Permaneça nesta página"
      ok-only
      ok-title="OK"
    >
      Para contabilizar seu tempo e possibilitar a geração do seu certificado,
      deixe esta janela aberta enquanto assiste à palestra.
    </b-modal>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar-user";
// import Chat from "@/components/Chat";
import { getAoVivo } from "@/services/api/Palestra";
import { registroAoVivo } from "@/services/api/usuarios";

export default {
  components: {
    Navbar,
    // Chat,
  },
  data() {
    return {
      palestra: undefined,
      isForbidden: false,
      palestraURL: "",
      chatURL: "",
    };
  },
  beforeCreate() {
    getAoVivo()
      .then((res) => {
        this.palestra = res.data;
        this.palestraURL = `https://www.youtube.com/embed/${this.palestra.ytURL}`;
        this.chatURL = `https://www.youtube.com/live_chat?v=${this.palestra.ytURL}&embed_domain=${window.location.hostname}`;
        const seconds = 15; //segundos;
        if (this.palestra) {
          setTimeout(() => {
            this.$bvModal.show("modal-pagina");
          }, 5 * 1000);
        }
        setInterval(() => {
          registroAoVivo({
            idPalestra: this.palestra._id,
            time: seconds,
          }).catch((err) => {
            console.error("Erro ao registrar tempo", err.response);
          });
        }, seconds * 1000);
      })
      .catch((err) => {
        console.error("Erro ao buscar palestra ao vivo", err.response);
        if (err.response.status == 403) {
          this.isForbidden = true;
          this.$bvModal.show("modal-permissao");
        }
      });
  },
  methods: {
    onOkModal() {
      this.$router.push("/palestras");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap");

.text-no-video {
  color: white;
  font-size: 2.5rem;
}
.live {
  font-family: Roboto;
  background-color: #000000;
  min-height: 100vh;
}
.title {
  color: #ffffff;
  text-align: center;
  padding-bottom: 23px;
  font-size: 38px;
  font-weight: 500;
}
.title-text {
  color: #ffffff;
  padding-top: 35px;
  font-size: 25px;
}
.text {
  color: #ffffff;
  padding-top: 12px;
  margin-bottom: 50px;
}
.video-link {
  border-radius: 15px;
}
.container {
  background-color: #000000;
}

@media only screen and (max-width: 998px) {
  .row {
    margin: 0px;
  }
}
@media only screen and (max-width: 575px) {
  .row {
    padding: 0px;
    margin: 0px;
  }
  .title {
    padding-top: 80px;
  }
  .text-no-video {
    font-size: 2rem;
  }
  .title-text {
    padding-left: 35px;
  }
  .text {
    padding-left: 35px;
    padding-right: 35px;
  }
  @media only screen and (max-width: 320px) {
    .title {
      font-size: 28px;
    }
    .title-text {
      font-size: 20px;
    }
    .text {
      font-size: 15px;
    }
  }
}
</style>
